import { Typeahead } from "react-bootstrap-typeahead";
import { Card, CardBody, Col, Form } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { COUNTRY_LIST, RTL_SUPPORT } from "../../../../Data/FormWidgets";
import { RTLSupport } from "../../../../Constant";

const RtlSupport = () => {
  return (
    <Col sm="12" md="6">
      <Card>
        <CommonCardHeader title={RTLSupport} span={RTL_SUPPORT} />
        <CardBody>
          <div id="scrollable-dropdown-menu">
            <Form className="theme-form">
              <div>
                <Typeahead options={COUNTRY_LIST} placeholder="Countries" id="RTL Support" />
              </div>
            </Form>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RtlSupport;
